<template>
  <Day day="23.12.2025">
    <div slot="page-content">
      <h3>Nachwuchs 😱🥰😍</h3>
      <p>
        <img src="@/assets/day23.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day23',
  components: {
    Day
  }
}
</script>
